import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group d-flex flex-wrap" }
const _hoisted_44 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "form-group d-flex flex-wrap" }
const _hoisted_47 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "form-group d-flex flex-wrap" }
const _hoisted_51 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group d-flex flex-wrap" }
const _hoisted_54 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-group d-flex align-items-center flex-wrap" }
const _hoisted_58 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "form-group d-flex flex-wrap" }
const _hoisted_62 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-12" }
const _hoisted_65 = { class: "form-group d-flex flex-wrap" }
const _hoisted_66 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_69 = { class: "svg-icon svg-icon-2" }
const _hoisted_70 = {
  key: 1,
  type: "button",
  class: "btn btn-danger me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_refuse_validation"
}
const _hoisted_71 = { class: "svg-icon svg-icon-2" }
const _hoisted_72 = { class: "indicator-label" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_74 = { class: "indicator-progress" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_76 = { class: "card mb-5 mb-xl-10" }
const _hoisted_77 = { class: "card-header border-0" }
const _hoisted_78 = { class: "card-title m-0" }
const _hoisted_79 = { class: "fw-boldest m-0" }
const _hoisted_80 = { class: "card-body border-top p-9" }
const _hoisted_81 = { class: "mb-10" }
const _hoisted_82 = { class: "m-0 ms-n4" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "svg-icon svg-icon-3" }
const _hoisted_85 = { class: "card mb-5 mb-xl-10" }
const _hoisted_86 = { class: "card-header border-0" }
const _hoisted_87 = { class: "card-title m-0" }
const _hoisted_88 = { class: "fw-boldest m-0" }
const _hoisted_89 = { class: "card-body border-top p-9" }
const _hoisted_90 = { class: "mb-10" }
const _hoisted_91 = ["innerHTML"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "svg-icon svg-icon-3" }
const _hoisted_94 = { class: "card mb-5 mb-xl-10" }
const _hoisted_95 = { class: "card-header border-0" }
const _hoisted_96 = { class: "card-title m-0" }
const _hoisted_97 = { class: "fw-boldest m-0" }
const _hoisted_98 = { class: "card-body border-top p-9" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-md-6" }
const _hoisted_101 = { class: "form-group d-flex flex-wrap" }
const _hoisted_102 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_103 = { class: "el-form-item__content" }
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = { class: "form-group d-flex flex-wrap" }
const _hoisted_106 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_107 = { class: "el-form-item__content" }
const _hoisted_108 = { class: "col-md-6" }
const _hoisted_109 = { class: "form-group d-flex flex-wrap" }
const _hoisted_110 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_111 = { class: "el-form-item__content" }
const _hoisted_112 = { class: "col-md-6" }
const _hoisted_113 = { class: "form-group d-flex flex-wrap" }
const _hoisted_114 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_115 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ShowContentModel = _resolveComponent("ShowContentModel")!
  const _component_RefuseValidationModal = _resolveComponent("RefuseValidationModal")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.action == 'save' ? _ctx.saveRules : _ctx.activeRules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("accountValidation.systemId")), 1),
                  _createVNode(_component_el_form_item, { prop: "system_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.__show.system_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.__show.system_id) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("influencerAccount.salutation")), 1),
                  _createVNode(_component_el_form_item, { prop: "salutation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.salutation,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.salutation) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.men'),
                            value: "1"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.women'),
                            value: "2"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("influencerAccount.firstname")), 1),
                  _createVNode(_component_el_form_item, { prop: "first_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.first_name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.first_name) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("influencerAccount.lastname")), 1),
                  _createVNode(_component_el_form_item, { prop: "last_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.last_name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.last_name) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("influencerAccount.source")), 1),
                  _createVNode(_component_el_form_item, { prop: "source" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.source,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.source) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("influencerAccount.channel")), 1),
                  _createVNode(_component_el_form_item, { prop: "channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.channel,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.channel) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelOptions, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group.label,
                              label: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("influencerAccount.industry")), 1),
                  _createVNode(_component_el_form_item, { prop: "industry" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.industry,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.industry) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("accountValidation.validationDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "validation_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.validation_date,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.validation_date) = $event)),
                        type: "datetime",
                        style: {"width":"100%"},
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("accountValidation.validatedDy")), 1),
                  _createVNode(_component_el_form_item, { prop: "validated_by" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.validated_by,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.validated_by) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchValidatedByItems,
                        loading: _ctx.validatedByLoading,
                        style: {"width":"100%"},
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validatedByOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("accountValidation.registrationMode")), 1),
                  _createVNode(_component_el_form_item, { prop: "registration_mode" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.registration_mode,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.registration_mode) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.registrationModeLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registrationModeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("accountValidation.registrationChannel")), 1),
                  _createVNode(_component_el_form_item, { prop: "registration_channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.registration_channel,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.registration_channel) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.registrationChannelLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registrationChannelOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("accountValidation.inviteDy")), 1),
                  _createVNode(_component_el_form_item, { prop: "invite_by" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.invite_by,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.invite_by) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchInviteByItems,
                        loading: _ctx.inviteByLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inviteByOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("accountValidation.recommendedDy")), 1),
                  _createVNode(_component_el_form_item, { prop: "recommended_by" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.recommended_by,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.recommended_by) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchRecommendedByItems,
                        loading: _ctx.recommendedByLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedByOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("accountValidation.inviteCampaign")), 1),
                  _createVNode(_component_el_form_item, { prop: "invite_campaign" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.invite_campaign,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.invite_campaign) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.inviteCampaignLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inviteCampaignOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("accountValidation.membershipLevel")), 1),
                  _createVNode(_component_el_form_item, { prop: "membership_level" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.membership_level,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.membership_level) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.membershipLevelLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membershipLevelOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.t("accountValidation.validationNotice")), 1),
                  _createVNode(_component_el_form_item, { prop: "validation_notice" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.validation_notice,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.validation_notice) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.t("accountValidation.refuseReason")), 1),
                  _createVNode(_component_el_form_item, { prop: "validation_notice" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.refuse_reason,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.refuse_reason) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_router_link, {
              to: '/task-management/account-validation/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_68,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (_ctx.formData.status == '10' || _ctx.formData.status == '40')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      class: "btn btn-success me-2",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onActiveClick && _ctx.onActiveClick(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_69, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.active")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.formData.status == '10')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_70, [
                      _createElementVNode("span", _hoisted_71, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil007.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.refuse")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  ref: "submitButton",
                  class: "btn btn-primary",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onSaveClick && _ctx.onSaveClick(...args)))
                }, [
                  _createElementVNode("span", _hoisted_72, [
                    _hoisted_73,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_74, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_75
                  ])
                ], 512)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("h3", _hoisted_79, _toDisplayString(_ctx.t("accountValidation.relatedSop")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createVNode(_component_el_table, {
                data: _ctx.options.sop,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.subject'),
                    prop: "subject",
                    width: "180"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.checkList')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("ol", _hoisted_82, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.check_list, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.check_list), 1))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_show_content",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        onClick: ($event: any) => (
                    _ctx.showContentModel(
                      _ctx.t('accountValidation.standardOperatingProcedure'),
                      row.check_list
                    )
                  )
                      }, [
                        _createElementVNode("span", _hoisted_84, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_83)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("h3", _hoisted_88, _toDisplayString(_ctx.t("accountValidation.standardScript")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createVNode(_component_el_table, {
                data: _ctx.options.standard_script,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardScript.subject'),
                    prop: "subject",
                    width: "180"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('accountValidation.script')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", {
                        innerHTML: row.script,
                        class: "pt-4"
                      }, null, 8, _hoisted_91)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_show_content",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        onClick: ($event: any) => (
                    _ctx.showContentModel(
                      _ctx.t('accountValidation.standardScript'),
                      row.script
                    )
                  )
                      }, [
                        _createElementVNode("span", _hoisted_93, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_92)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_94, [
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("h3", _hoisted_97, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_103, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_107, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_111, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_115, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_ShowContentModel, {
      title: _ctx.showTitle,
      content: _ctx.showContent
    }, null, 8, ["title", "content"]),
    _createVNode(_component_RefuseValidationModal, {
      id: parseInt(_ctx.$route.params.id),
      onUpdateInfo: _ctx.getAccountValidationInfo
    }, null, 8, ["id", "onUpdateInfo"])
  ], 64))
}